import OrderDTO from "@/dto/order/OrderDTO";
import { PrintRule, PrintRuleLevel, RuleHit, PrintCheckResult } from "../types";

export async function evaluatePrintRules(orders: OrderDTO[], rules: PrintRule[]): Promise<PrintCheckResult> {
    const ruleHits: RuleHit[] = rules.map((r) => ({ rule: r, orders: [] }));

    for (const order of orders) {
        for (const hit of ruleHits) {
            if (await hit.rule.match(order)) {
                hit.orders.push(order);
            }
        }
    }

    const forbidden = ruleHits.filter((h) => h.rule.level === PrintRuleLevel.FORBIDDEN && h.orders.length);

    const optional = ruleHits.filter((h) => h.rule.level === PrintRuleLevel.OPTIONAL && h.orders.length);

    const forbiddenOrderIds = new Set<number>();
    forbidden.forEach((h) => h.orders.forEach((o) => forbiddenOrderIds.add(o.id)));

    // 从optional的orders中排除被forbidden的订单
    const filteredOptional = optional.map((hit) => ({
        ...hit,
        orders: hit.orders.filter((order) => !forbiddenOrderIds.has(order.id)),
    })).filter((hit) => hit.orders.length > 0);

    // 构建订单ID -> 命中的optional规则ID列表的映射（只使用未被forbidden的订单）
    const orderToOptionalRules = new Map<number, string[]>();
    filteredOptional.forEach((hit) => {
        hit.orders.forEach((order) => {
            if (!orderToOptionalRules.has(order.id)) {
                orderToOptionalRules.set(order.id, []);
            }
            orderToOptionalRules.get(order.id).push(hit.rule.id);
        });
    });

    // 计算至少命中一个optional规则的订单数量（去重）
    const optionalOrderCount = orderToOptionalRules.size;

    return {
        totalOrders: orders,
        forbidden,
        optional: filteredOptional,
        forbiddenOrderIds,
        orderToOptionalRules,
        optionalOrderCount,
    };
}
